module.exports = __webpack_public_path__ + "img/product-placeholder-79.ca25e9f.png";